import { render, staticRenderFns } from "./digipayTransactions.vue?vue&type=template&id=78598ba4&scoped=true&"
import script from "./digipayTransactions.vue?vue&type=script&lang=js&"
export * from "./digipayTransactions.vue?vue&type=script&lang=js&"
import style0 from "./digipayTransactions.vue?vue&type=style&index=0&id=78598ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78598ba4",
  null
  
)

export default component.exports